import React from 'react'
import styled from 'styled-components'

import ampmeLogo from '../../assets/images/ampme-logo.png'
import availableDevicesExample from '../../assets/images/example.png'
import downloadIOS from '../../assets/images/dwl_iphone.svg'
import downloadAndroid from '../../assets/images/dwl_android.svg'

import Image from '../shared/image'
import Link from '../shared/link'
import Minimizer from '../shared/minimizer'

import { device } from '../../lib/deviceSizes'

const Main = styled.div`
  display: flex;

  position: relative;
  height: 100%;
  max-height: 400px;
  width: 100%;
  max-width: 600px;

  border: 1px solid #f1f1f1;
  background-color: #ffffff;

  @media ${device.xSmall} {
    height: 99%; /* when embedded in a iframe, we want 1 px to display the border */
    width: 99%; /* when embedded in a iframe, we want 1 px to display the border */
    margin: 0 auto;
  }
`

const LeftPanel = styled.div`
  height: 100%;
  width: 50%;
  padding-left: 20px;
  padding-right: 20px;

  background-image: linear-gradient(224deg, #00fff2, #00b4fe);

  @media ${device.xSmall} {
    padding-left: 3.25vw;
    padding-right: 3.25vw;
  }
`

const Logo = styled(Image).attrs({
  src: ampmeLogo
})`
  max-width : 135px;
  margin-top: 10px;
`

const Title = styled.div`
  padding-top: 5px;
  padding-left: 10px;
  padding-bottom: 5px;

  font-weight: 600;
  font-size: 20px;

  @media ${device.xSmall} {
    font-size: 3.25vw;
  }
`

const SubTitle = styled.div`
  padding: 20px 20px 0 10px;

  font-weight: 600;
  font-size: 16px;

  @media ${device.xSmall} {
    padding: 3.25vw 3.25vw 0 1.5vw;

    font-size: 2.5vw;
  }
`

const RightPanel = styled.div`
  display: flex;
  align-items: center;

  height: 100%;
  width: 50%;
`

const Example = styled(Image).attrs({
  src: availableDevicesExample
})`
  height: 87%;
  margin-left: 1vw;
`

const LinkContainer = styled.div`
  margin-right: 20px;
  margin-top: 5px;
`

const Links = styled.div`
  display: flex;
  align-items: center;

  margin: 0 auto;
  margin-bottom: -5px;
`

const IOSButton = styled(Image).attrs({
  src: downloadIOS
})`
  max-width: 115px;
  width: 100%;
`

const AndroidButton = styled(Image).attrs({
  src: downloadAndroid
})`
  max-width: 130px;
  width: 100%;
`

export const HowToCast = () => (
  <Main>
    <Minimizer />
    <LeftPanel>
      <Logo />
      <Title>
        Hey letʼs connect this device!
      </Title>
      <SubTitle>
        1. Get the mobile app
        <Links>
          <LinkContainer>
            <Link url="https://itunes.apple.com/app/apple-store/id986905979">
              <IOSButton />
            </Link>
          </LinkContainer>
          <LinkContainer>
            <Link url="https://play.google.com/store/apps/details?id=com.amp.android">
              <AndroidButton />
            </Link>
          </LinkContainer>
        </Links>
      </SubTitle>
      <SubTitle>
        2. Make sure both this computer and your mobile device are on the same wifi network.
      </SubTitle>
      <SubTitle>
        3. Open the AmpMe App and click on the Devices Available inside a party.
      </SubTitle>
    </LeftPanel>
    <RightPanel>
      <Example />
    </RightPanel>
  </Main>
)



// WEBPACK FOOTER //
// ./src/components/howToCast/howToCast.js